import React, { useEffect, useState, useRef } from "react";
import {
  FaFileExcel,
  FaFileCode,
  FaNetworkWired,
  FaSalesforce,
  FaArrowLeft,
} from "react-icons/fa";
import MicrosoftFabric from "../../../../assets/microsoftFabric.png";
import CrateDb from "../../../../assets/crateDb.png";
import C4C from "../../../../assets/c4c.png";
import IBMDB2Logo from "../../../../assets/IBMDB2logo1.png";
import { SiPostgresql, SiMysql } from "react-icons/si";
import Modal from "../../../common/Modal/Modal";
import Spinner from "../../../common/Spinner/Spinner";
import axiosClient from "../../../../api-client/AxiosClient";
import { toast } from "react-toastify";
import { showError } from "../../../common/Utils";
import { useNavigate} from "react-router-dom";
import sql from "../../../../assets/sql1.png";
import sap from "../../../../assets/sap.png";
import sage from "../../../../assets/Sage.png";
import odoo from "../../../../assets/odoo.png";
import sugarcrm from "../../../../assets/sugarcrm.png";
import infor from "../../../../assets/Infor.png";
import bullhorn from "../../../../assets/Bullhorn.png";
import exact from "../../../../assets/exact.png";
import dynamicsax from "../../../../assets/dynamicsax.png";
import jdedwards from "../../../../assets/JDEdwards.png";
import Microcrm from "../../../../assets/Microcrm.png";
import { fetchAESKey, encryptText, isKeyLoaded } from "../../../../utils/encryption";
import { fieldConfig } from "./dataSourceFieldConfig";

const DataSource = () => {

  // Get corporation from localStorage
  const getSelectedCorporation = () => {
    const stored = localStorage.getItem("selectedCorporation");
    return stored ? JSON.parse(stored) : null;
  };

  const [search, setSearch] = useState("");
  const [selectedType, setSelectedType] = useState(null);
  const [formData, setFormData] = useState({
    server: "",
    description: "",
    port: "",
    isActive: true,
    corporationDbName: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [corporations, setCorporations] = useState([]);
  const [mappingDBs, setMappingDBs] = useState([]);
  const dataFetched = useRef(false);
  const navigate = useNavigate();

  const handleBack = () => navigate("/data-sources");

  const handleSourceClick = (type) => {
    setSelectedType(type);

    const storedCorporation = getSelectedCorporation();
    const corporationId = storedCorporation ? storedCorporation.value : null;

    let defaultMappingDB = { name: "", description: "", isActive: true };

const typeToDBNameMap = {
  postgresql: "PostgresSQL",
  sqlserver: "MsSql",
  microsoft_fabric: "Fabric",  // Changed from "MsSql"
  CrateDb: "CrateDb",
  db2: "Db2",
  sap_hana: "S4HANA",
  sap_c4c: "S4HANA",  // Changed from "SAP_HANA"
  mysql: "MySql",
  excel_csv: "Excel",  // Added
  xml: "Xml",  // Added
  json: "Json",  // Added
  api: "API",  // Added
  salesforce: "SalesForce",  // Added
    ms_dynamics_ax: "Microsoft Dynamics Ax2012",  // Added
    odoo: "Odoo",  
};

if (mappingDBs.length > 0 && typeToDBNameMap[type]) {
  const matchingDB = mappingDBs.find(
    (db) => db.name === typeToDBNameMap[type]
  );

  if (matchingDB) {
    defaultMappingDB = matchingDB;
  }
}



    setFormData({
      server: "",
      database: "",
      username: "",
      password: "",
      host: "",
      baseUrl: "", 
      port: "",
      corporationDbName: "",
      description: defaultMappingDB.description,
      isActive: defaultMappingDB.isActive,
      mappingDbId: defaultMappingDB.mappingdbId,
      Corporation: corporationId || "",
    });

    setShowModal(true);
  };

  const isFormValid = () => {
    const fields = fieldConfig[selectedType] || [];
    return fields.every((field) => {
      const value = formData[field.name];
      if (!field.required) return true;

      if (field.type === "file") {
        return value instanceof File;
      }
      return value !== undefined && value !== "" && value !== null;
    });
  };

  const handleInputChange = (e) => {
    const { name, value, files, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

const buildDatabasePayload = () => {
  const storedCorporation = getSelectedCorporation();
  const corporationId = storedCorporation?.value || null;
  const organizationConfigId = localStorage.getItem("organization_config_id");
  
return {
  organizationId: corporationId,
  database: formData.database || "",
  server: formData.server || "",
  username: formData.username || "",
  password: formData.password ? encryptText(formData.password) : "",
  host: formData.host || "",
...(selectedType === "odoo" && { baseURL: formData.baseUrl || "" }),

  port: formData.port || "",
  description: formData.description || "",
  organizationDbName: formData.corporationDbName || "",
  isActive: formData.isActive,
  datasource_id: formData.mappingDbId || "",
  organization_config_id: organizationConfigId || "",
  ...(selectedType === "api" && {
  host: formData.endpoint || "",
  headers: formData.headers || "",
}),

};

};

  const handleDatabaseSubmit = async () => {
    try {
      const payload = buildDatabasePayload();
      if (selectedType === "mysql") {
        payload.name = formData.name || "MySQL";
      } else if (selectedType === "CrateDb") {
        payload.name = formData.name || "CrateDb";
      } else if (selectedType === "db2") {
        payload.name = "Db2";
       } else if (selectedType === "ms_dynamics_ax") {
  payload.name = "ms_dynamics_ax";
} else if (selectedType === "odoo") {
  payload.name = "Odoo";
} else if (selectedType === "api") {
  payload.name = "API";
}

      const response = await axiosClient.post("/api/MappingDB/CorpMappingDB", payload);
      return response;
    } catch (error) {
      // Handle 500 Internal Server Error specifically
      if (error.response?.status === 500) {
        const errorMessage = error.response?.data?.message || error.response?.data?.error || "Internal server error occurred. Please try again later.";
        toast.error(errorMessage);
        throw new Error(errorMessage);
      }
      // Re-throw other errors to be handled by the caller
      throw error;
    }
  };

  const handleSAPHanaSubmit = async () => {
    const payload = buildDatabasePayload();
    payload.name = "S4HANA";
    return axiosClient.post("/api/MappingDB/CorpMappingDB", payload);
  };

const handleSalesforceSubmit = async () => {
  const storedCorporation = getSelectedCorporation();
  const corporationId = storedCorporation?.value || null;
  const organizationConfigId = localStorage.getItem("organization_config_id");
  
  const payload = {
    organizationId: corporationId,
    consumerKey: formData.consumerKey ? encryptText(formData.consumerKey) : "",
    consumerSecret: formData.consumerSecret ? encryptText(formData.consumerSecret) : "",
    securityToken: formData.securityToken ? encryptText(formData.securityToken) : "",
    username: formData.username || "",
    password: formData.password ? encryptText(formData.password) : "",
    organizationDbName: formData.CorporationDbName || "",  // Changed from corporationDbName
    isActive: true,
    datasource_id: mappingDBs.find(db => db.name === "SalesForce")?.mappingdbId || "",  // Added
    organization_config_id: organizationConfigId || ""  // Added
  };
  return axiosClient.post("/api/MappingDB/CorpMappingDB", payload);
};

  const handleFileUpload = async (endpoint) => {
    const dataToSend = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      dataToSend.append(key, value);
    });
    return axiosClient.post(endpoint, dataToSend);
  };

  const handleSubmit = async () => {
    if (!selectedType) return;

    const storedCorporation = getSelectedCorporation();
    const corporationId = storedCorporation?.value || null;

    if (!corporationId) {
      toast.error("Please select an Organization from the header");
      return;
    }

    try {
      setLoading(true);
      
      // Ensure AES key is loaded before encrypting
      if (!isKeyLoaded()) {
        await fetchAESKey();
      }

      let response;

switch (selectedType) {
  case "sqlserver":
  case "postgresql":
  case "mysql":
  case "CrateDb":
  case "db2":
  case "ms_dynamics_ax":
  case "odoo":
  case "api":
    response = await handleDatabaseSubmit();
    break;

        case "sap_hana":
          response = await handleSAPHanaSubmit();
          break;
        case "salesforce":
          response = await handleSalesforceSubmit();
          break;
        case "json":
          response = await axiosClient.post("/api/upload/json", formData);
          break;
        case "xml":
          response = await handleFileUpload("/api/upload/xml");
          break;
        case "excel_csv":
          response = await handleFileUpload("/api/upload/excel");
          break;
        default:
          toast.warning("API not configured for this source.");
          return;
      }

      if (response.status === 200) {
        toast.success("Connection created successfully!");
        setShowModal(false);
      } else {
        throw new Error("No response data received");
      }
    } catch (err) {
      showError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.detail.key === "selectedCorporation") {
        // Storage change listener - no state update needed
      }
    };

    // eslint-disable-next-line no-undef
    globalThis.addEventListener("customStorageChange", handleStorageChange);
    return () => {
      // eslint-disable-next-line no-undef
      globalThis.removeEventListener("customStorageChange", handleStorageChange);
    };
  }, []);

  const sourceData = [
    { id: "json", name: "JSON", icon: <FaFileCode size={40} color="#006400" /> },
    { id: "xml", name: "XML", icon: <FaFileCode size={40} color="#CC2927" /> },
    { id: "excel_csv", name: "Excel/CSV", icon: <FaFileExcel size={40} color="#217346" /> },
    { id: "api", name: "API", icon: <FaNetworkWired size={40} color="#007bff" /> },
    { id: "postgresql", name: "PostgreSQL", icon: <SiPostgresql size={40} color="#336791" />, mappingDbName: "PostgresSQL" },
    { id: "mysql", name: "MySQL", icon: <SiMysql size={40} color="#00758F" />, mappingDbName: "MySQL" },
    { id: "sqlserver", name: "SQL Server", icon: <img src={sql} alt="SQL" style={{ height: "40px" }} />, mappingDbName: "MsSql" },
    { id: "CrateDb", name: "Cratedb", icon: <img src={CrateDb} alt="CrateDb" style={{ height: "40px" }} />, mappingDbName: "CrateDb" },
    { id: "db2", name: "DB2", icon: <img src={IBMDB2Logo} alt="DB2" style={{ height: "40px" }} />, mappingDbName: "Db2" },
    { id: "sap_hana", name: "SAP HANA", icon: <img src={sap} alt="SAP" style={{ height: "40px" }} />, mappingDbName: "SAP_HANA" },
    { id: "salesforce", name: "Salesforce", icon: <FaSalesforce size={40} color="#007bff" /> },
{ id: "microsoft_fabric", name: "MS Fabric", icon: <img src={MicrosoftFabric} alt="Microsoft Fabric" style={{ height: "40px" }} />, mappingDbName: "Fabric" },  // Changed
{ id: "sap_c4c", name: "SAP C4C", icon: <img src={C4C} alt="C4C" style={{ height: "40px" }} />, mappingDbName: "S4HANA" },  // Changed
    { id: "exact", name: "Exact ERP", icon: <img src={exact} alt="Exact" style={{ height: "40px" }} />, mappingDbName: "Exact" },
    { id: "sage", name: "Sage", icon: <img src={sage} alt="Sage" style={{ height: "40px" }} />, mappingDbName: "Sage" },
    { id: "odoo", name: "Odoo ERP", icon: <img src={odoo} alt="Odoo" style={{ height: "40px" }} />, mappingDbName: "Odoo" },
    { id: "sugarcrm", name: "SugarCRM", icon: <img src={sugarcrm} alt="SugarCRM" style={{ height: "40px" }} />, mappingDbName: "SugarCRM" },
    { id: "ms_dynamics_ax", name: "MS Dynamics AX", icon: <img src={dynamicsax} alt="Dynamics AX" style={{ height: "40px" }} />, mappingDbName: "DynamicsAX" },
    { id: "ms_dynamics_crm", name: "MS Dynamics CRM", icon: <img src={Microcrm} alt="Dynamics CRM" style={{ height: "40px" }} />, mappingDbName: "DynamicsCRM" },
    { id: "ms_dynamics_nav", name: "MS Dynamics NAV", icon: <img src={Microcrm} alt="Dynamics NAV" style={{ height: "40px" }} />, mappingDbName: "DynamicsNAV" },
    { id: "jdedwards", name: "JD Edwards", icon: <img src={jdedwards} alt="JD Edwards" style={{ height: "40px" }} />, mappingDbName: "JDEdwards" },
    { id: "infor", name: "Infor", icon: <img src={infor} alt="Infor" style={{ height: "40px" }} />, mappingDbName: "Infor" },
    { id: "bullhorn", name: "Bullhorn", icon: <img src={bullhorn} alt="Bullhorn" style={{ height: "40px" }} />, mappingDbName: "Bullhorn" },
  ];

  const filteredSources = sourceData.filter((source) =>
    source.name.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    const fetchData = async () => {
      if (dataFetched.current) return;
      setLoading(true);
      dataFetched.current = true;

      try {
              await fetchAESKey();

        const corpResponse = await axiosClient.get("/api/Organization/GetUserOrganizations");
        if (corpResponse?.data) {
          const distinctCorporations = Array.from(
            new Map(corpResponse.data.map((item) => [item.organizationId, item])).values()
          );
          setCorporations(distinctCorporations);
        }

        const mappingResponse = await axiosClient.get("/api/MappingDB");
        if (mappingResponse?.data) {
          setMappingDBs(mappingResponse.data);
        }
      } catch (error) {
        showError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
<div className="import-container" style={{ paddingBottom: "80px" }}>
      {loading && <Spinner />}

<div className="flex items-center justify-between mb-4 px-4">
  <h2 className="text-2xl font-bold text-gray-900">Add Data Source</h2>
  <button
    onClick={handleBack}
    className="flex items-center text-blue-600 hover:text-blue-800 p-2 rounded hover:bg-blue-50 transition-colors"
    title="Go back"
  >
    <FaArrowLeft className="mr-2" />
    Back
  </button>
</div>

      <div className="search-box">
        <input
          type="text"
          placeholder="Search for sources"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

<div className="data-sources" style={{ paddingBottom: "20px" }}>
        {filteredSources.map((source) => (
          <button
            key={source.id}
            type="button"
            className="source-card"
            onClick={() => handleSourceClick(source.id)}
            aria-label={`Add ${source.name} data source`}
          >
            {source.icon}
            <p>{source.name}</p>
          </button>
        ))}
      </div>

      <Modal
        show={showModal}
        title={`Configure ${selectedType?.toUpperCase()} Source`}
        setShowModal={setShowModal}
      >
        {fieldConfig[selectedType]?.map((field) => {
          const shouldSkipField = (field.name === "name" || field.name === "description") &&
            selectedType &&
            sourceData.find((s) => s.id === selectedType)?.mappingDbName;
          
          if (shouldSkipField) {
            return null;
          }

          const isRequired = field.required;
          const placeholder = isRequired ? `Enter ${field.label}` : `Enter ${field.label} (Optional)`;
          const isDropdown = field.type === "dropdown";
          const isTextarea = field.type === "textarea";

          return (
            <div key={field.name} className="modal-field">
              <label htmlFor={field.name}>
                {field.label}
                {isRequired && <span className="text-red-500 ml-1">*</span>}
              </label>
              {isDropdown && (
                <select
                  id={field.name}
                  name={field.name}
                  onChange={handleInputChange}
                  value={formData[field.name] || ""}
                  disabled={corporations.length === 1}
                  className={`form-select ${isRequired ? "required" : ""}`}
                  required={isRequired}
                >
                  <option value="" disabled>
                    Select {field.label}
                  </option>
                  {corporations.map((corp) => (
                    <option key={corp.organizationId} value={corp.organizationId}>
                      {corp.name}
                    </option>
                  ))}
                </select>
              )}
              {isTextarea && (
                <textarea
                  id={field.name}
                  name={field.name}
                  onChange={handleInputChange}
                  value={formData[field.name] || ""}
                  className={isRequired ? "required" : ""}
                  required={isRequired}
                  placeholder={placeholder}
                />
              )}
              {!isDropdown && !isTextarea && (
                <input
                  id={field.name}
                  name={field.name}
                  type={field.type}
                  value={formData[field.name] || ""}
                  onChange={handleInputChange}
                  className={isRequired ? "required" : ""}
                  required={isRequired}
                  placeholder={placeholder}
                />
              )}
            </div>
          );
        })}

        <div className="modal-actions">
          <button className="cancel-btn" onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button
            type="button"
            className={`submit-btn ${isFormValid() ? "" : "disabled"}`}
            onClick={handleSubmit}
            disabled={!isFormValid()}
          >
            Submit
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default DataSource;
